<template>
  <div class="clock" :class="{'archive': archive}" @click="onClick">
    <img :src="archive ? clockBgArchive : clockBg">
    <img class="hour" :src="clockHour">
    <img class="minute" :src="clockMinute">
    <img class="second" :src="clockSecond">
  </div>
</template>

<script>

import clockBg from '@/assets/img/watch_clockbg.png'
import clockBgArchive from '@/assets/img/watch_clockbg-archive.png'
import clockHour from '@/assets/img/watch_hour.png'
import clockMinute from '@/assets/img/watch_minute.png'
import clockSecond from '@/assets/img/watch_second.png'

export default {
  name: 'Clock',
  props: {
    archive: Boolean,
    newroute: String
  },
  data () {
    const onClick = () => {
      if (this.archive) {
        this.$router.push({ name: this.newroute })
      }
    }
    return {
      clockBgArchive,
      clockBg,
      clockHour,
      clockMinute,
      clockSecond,
      onClick
    }
  }
}
</script>

<style lang="scss" scoped>
.clock {
  position: absolute;
  z-index: 4;
  top: 40px;
  right: 40px;

  width: 10vw;
  height: 10vw;

  &.archive {
    width: 12vw;
    height: 12vw;
    cursor: pointer;

    .hour,
    .minute,
    .second {
      position: absolute;
      width: 80%;
      height: 80%;
      top: 10%;
      left: 10%;
    }
  }

  img {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .hour {
    animation: spin 10s infinite linear;
  }

  .minute {
    animation: spin 5s infinite linear;
  }

  .second {
    animation: spin 2s infinite linear;
  }
}

@keyframes spin {
  from {
    transform: rotate(360deg);
  }

  to {
    transform: rotate(0deg);
  }
}
</style>
